import * as React from 'react';
// tslint:disable-next-line: match-default-export-name
import classNames from 'classnames';

import * as styles from './styles.css';

interface IInfrastructurePlacemarkCircle {
  children: React.ReactNode;
  className?: string;
}

export const InfrastructurePlacemarkCircle = (props: IInfrastructurePlacemarkCircle) => (
  <div {...props} className={classNames(styles['placemark'], props.className)} />
);
